import PLAYER_ERRORS from './PLAYER_ERRORS';

const playerErrorResolver = {
  resolveHlsStreamingError(videoSource) {
    return new Promise((resolve, reject) => {
      const sources = videoSource.sources;
      const newSources = videoSource.sources.filter(source => source.meta.mimeType === 'video/mp4');

      if (newSources.length === sources.length) {
        // Nothing changed. Returned source most likely will not work.
        return reject(new Error(PLAYER_ERRORS.UNABLE_TO_RECOVER));
      }
      return resolve({
        ...videoSource,
        sources: newSources,
      });
    });
  },

  /**
   * Handle media loading error by attempt to fallback user to hosted source
   */
  resolveMediaLoadingError(videoSource) {
    const sources = videoSource.sources;
    const firstSource = sources[0];

    if (firstSource.meta.provider === 'hosted') {
      // The existing source are provided by 'hosted'. There is nothing else to fallback to
      return Promise.reject(new Error(PLAYER_ERRORS.UNABLE_TO_RECOVER));
    }
    return Promise.resolve();
  },
};

export default playerErrorResolver;
